import config from '@/config/prod.env';
import header from '@/helper/header';
import common from '@/helper/common';

const mainUrl = `${process.env.VUE_APP_API_URL}/RoleMenu`;

export default {      
    getByRoleIdAndMenuIds: async (roleId, menuIds) => {
        const requestOptions = {
            method: 'POST',
            headers: await header.authHeaderWithToken(),
            body: JSON.stringify({ 
                "roleId": roleId,
                "menuIds": menuIds
            })
        };
    
        let rs = await fetch(`${mainUrl}/GetByRoleIdAndMenuIds`, requestOptions);
        return await common.handleResponse(rs);
    },
    
    createMultiple: async (body) => {
        var requestOptions = {
            method: 'POST',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify(body),
        };
    
        let rs = await fetch(`${mainUrl}/CreateMultiple`, requestOptions);
        return await common.handleResponse(rs);
    },

    deleteByRoleIdAndMenuIds: async (roleId, menuIds) => {
        var requestOptions = {
            method: 'DELETE',
            headers: header.authHeaderWithToken(),
            body: JSON.stringify({
                "roleId": roleId,
                "menuIds": menuIds
            }),
        };
    
        let rs = await fetch(`${mainUrl}/DeleteByRoleIdAndMenuIds`, requestOptions);
        return await common.handleResponse(rs);
    },
}